import React from 'react';

export type StatusChipName = 'completed' | 'InProgress' | 'todo';
export type StatusChipLabel = string;

interface StatusChipProps {
  name: StatusChipName;
  label: StatusChipLabel;
  count?: number;
  selected?: boolean;
  onClick?: (name: StatusChipName) => void;
  height?: number;
}

const StatusChip: React.FC<StatusChipProps> = ({ name, label, count, selected, onClick, height = 28 }) => {
  let color = '#E17E61';
  let border = '1px solid #E17E61';
  let background = '#FFF6F2';
  let boxShadow = '0 1px 4px #e17e6122';

  if (name === 'completed') {
    color = '#2DB96F';
    border = '1px solid #2DB96F';
    background = '#F6FFF9';
    boxShadow = '0 1px 4px #2db96f22';
  } else if (name === 'todo') {
    color = '#1976D2';
    border = '1px solid #1976D2';
    background = '#F0F6FF';
    boxShadow = '0 1px 4px #1976d222';
  }

  const CHIP_WIDTH = 150;
  const [isHovered, setIsHovered] = React.useState(false);

  const baseStyle: React.CSSProperties = {
    color: selected ? '#fff' : color,
    border,
    borderRadius: 16,
    padding: '2px 0',
    fontWeight: 500,
    fontSize: 13,
    background: selected ? color : background,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: CHIP_WIDTH,
    textAlign: 'center',
    transition: 'all 0.2s',
    boxShadow,
    height,
    cursor: onClick ? 'pointer' : 'default',
    userSelect: 'none',
  };

  const hoverStyle: React.CSSProperties =
    typeof count === 'number'
      ? {
        boxShadow: `${boxShadow}, 0 0 0 4px ${color}33`,
        transform: 'scale(1.04)',
      }
      : {};

  return (
    <span
      data-testid={`status-chip-${name}`}
      style={isHovered ? { ...baseStyle, ...hoverStyle } : baseStyle}
      onClick={onClick ? () => onClick(name) : undefined}
      onMouseEnter={() => {
        if (typeof count === 'number') setIsHovered(true);
      }}
      onMouseLeave={() => setIsHovered(false)}
    >
      {label}
      {typeof count === 'number' ? ` : ${count.toString().padStart(2, '0')}` : ''}
    </span>
  );
};

export default StatusChip;